<template>
  <div class="main-wraper-main-page">
    <nb-welcome-page
      class="welcome-page"
      domain="onboard"
      :img="avionLigneImage"
    >
      <div class="main_page_text">
        <div class="welcome-page-container-tittle">
          <p>Welcome to the NAVBLUE Delivery Portal</p>
        </div>
        <nb-layout-grid class="layout-grid-menu">
          <nb-row class="layout-row-tittle">
            <nb-col type="sm" no-gutters>
              <div class="block block--light">
                <nb-text type="sm-center" class="layout-menu-tittle">
                  &nbsp; SUPPORT &nbsp;
                </nb-text>
              </div>
            </nb-col>
          </nb-row>
          <nb-row class="layout-row">
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="deliverySupportLink" class="block block--light">
                  <a
                    href="mailto:navdatasupport@navblue.aero  "
                    class="icon-block"
                    target="_blank"
                  >
                    <nb-icon name="mail_sent" size="50" class="nav-icon" />
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Delivery Support</p>
                </div>
              </nb-row>
            </nb-col>
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="supportPortalLink" class="block block--light">
                  <a
                    href="https://www.navblue.aero/support/"
                    class="icon-block"
                    target="_blank"
                  >
                    <i class="fas fa-cogs fa-2x"></i>
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Support Portal</p>
                </div>
              </nb-row>
            </nb-col>
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="navblueAcademyLink" class="block block--light">
                  <a
                    href="https://navblueacademy.support.navblue.aero/support/home"
                    class="icon-block"
                    target="_blank"
                  >
                    <i class="fas fa-university fa-2x"></i>
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Navblue Academy</p>
                </div>
              </nb-row>
            </nb-col>
          </nb-row>
          <nb-row class="layout-row-tittle">
            <nb-col type="sm" no-gutters>
              <div class="block block--light">
                <nb-text type="sm-center" class="layout-menu-tittle">
                  &nbsp; PRODUCTS and SERVICES &nbsp;
                </nb-text>
              </div>
            </nb-col>
          </nb-row>
          <nb-row class="layout-row">
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="navblueWebsiteLink" class="block block--light">
                  <a
                    href="https://www.navblue.aero/"
                    class="icon-block"
                    target="_blank"
                  >
                    <nb-icon name="navblue_brand" size="50" class="nav-icon" />
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Navblue Website</p>
                </div>
              </nb-row>
            </nb-col>
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="onBoardSolutionsLink" class="block block--light">
                  <a
                    href="https://www.navblue.aero/supply-aero-data/"
                    class="icon-block"
                    target="_blank"
                  >
                    <nb-icon name="area_radar" size="50" class="nav-icon" />
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Supply Aero Data</p>
                </div>
              </nb-row>
            </nb-col>
            <nb-col type="sm-4">
              <nb-row type="sm" class="layout-menu-icon">
                <div id="navbleNewsLink" class="block block--light">
                  <a
                    href="https://www.navblue.aero/news/"
                    class="icon-block"
                    target="_blank"
                  >
                    <i class="far fa-newspaper fa-2x"></i>
                  </a>
                </div>
              </nb-row>
              <nb-row type="sm" class="layout-menu-name">
                <div>
                  <p>Navblue News</p>
                </div>
              </nb-row>
            </nb-col>
          </nb-row>
          <div class="d-flex justify-content-end bd-highlight mb-default">
            <div id="linkedInLink" class="p-s bd-highlight">
              <a
                href=" https://www.linkedin.com/company/navblue-an-airbus-company/ "
                target="_blank"
              >
                <i class="fab fa-linkedin"></i>
              </a>
            </div>
            <div id="twitterLink" class="p-s bd-highlight">
              <a href="https://twitter.com/navblue_aero" target="_blank">
                <i class="fab fa-twitter-square"></i>
              </a>
            </div>
          </div>
        </nb-layout-grid>
      </div>
    </nb-welcome-page>
  </div>
</template>
<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import { WelcomePage } from "@navblue/navblue-ui";
import {
  isMobile,
  mobileVendor,
  browserName,
  browserVersion,
  osName
} from "mobile-device-detect";
import * as API from "../API/APIFunctions.js";

@Component({
  components: {
    NbWelcomePage: WelcomePage
  },
  computed: {
    avionLigneImage: function() {
      return this.publicPath + "avion-ligne.png";
    }
  }
})
export default class MyApp extends Vue {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      msg: isMobile
        ? "Welcome to Your Vue.js mobile App!" +
          mobileVendor +
          " " +
          browserName +
          " " +
          browserVersion +
          " " +
          osName
        : "Welcome to Your Vue.js App"
    };
  }

  mounted() {
    if (
      !!this.$store.getters.getBulletinId &&
      !!this.$store.getters.getBulletinType
    ) {
      API.viewPdf(
        this.$store.getters.getBulletinId,
        this.$store.getters.getBulletinType
      );
    }
    this.$store.commit("setBulletinId", "");
    this.$store.commit("setBulletinType", "");
  }
}
</script>
<style lang="scss">
.main-container {
  padding-left: 10px;
  padding-right: 10px;

  .main-wraper-main-page {
    position: relative;
    height: 100vh;
    margin-top: calc(-3.4 * var(--spacer-default));

    .welcome-page {
      a:link,
      a:visited {
        color: white;
      }
      a:hover {
        color: grey;
      }
      .nb-welcome-page__corner-icon {
        width: calc(8 * var(--unit));
        height: calc(8 * var(--unit));
        position: absolute;
        bottom: 2%;
        left: 40%;
      }
      .welcome-page-container-tittle {
        font-size: var(--font-size-h-2);
        text-align: center;
        p {
          margin-bottom: 0px var(--spacer-xl);
          margin-top: 0px var(--spacer-xl);
        }
      }
      .nb-welcome-page__form {
        padding-left: calc(2 * var(--spacer-default)); //48px
        padding-right: calc(2 * var(--spacer-default)); //48px
        .nb-welcome-page__formcontent {
          padding-bottom: 0px var(--spacer-xl);
        }
        .layout-menu-name {
          font-size: var(--font-size-h-3);
        }
        .layout-menu-name,
        .layout-menu-icon {
          display: flex;
          align-content: center;
          justify-content: center;
          .nav-icon {
            stroke-width: 3px !important;
          }
        }
        width: 40%;
        padding-top: calc(3 * var(--spacer-default)); //48px
      }
      .layout-menu-tittle {
        display: flex;
        align-items: center;
        text-align: center;
        padding-bottom: 4vh;
        padding-top: 5vh;
      }
      .layout-menu-tittle::before,
      .layout-menu-tittle::after {
        content: "";
        flex: 1;
        border-bottom: 2px solid white;
      }
      .layout-menu-icon-and-name {
        text-align: center;
        .icon-block {
          text-align: center;
        }
      }
    }
    .main_page_text {
      font-size: var(--font-size-h-2);
      font-weight: bold;
    }
  }
}
</style>
